import { useEffect } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import FormRegisterUser from './FormRegisterUser';
import Actions from "../../redux/actions";


const Section = styled.section`

    .form-register-user__container{
      display: flex;
      justify-content: center;

      & > * {
        width: 70%;
        @media screen and (max-width: 768px) {
        width: 80%;
      }

      @media screen and (max-width: 450px) {
        width: 100%;
      }
      }
    }

    .text{
      font-size: 22px;
      @media only screen and (max-width:1279.9px){
        font-size:18px;
      }
      @media only screen and (max-width:767.9px){
        font-size:16px;
      }

    }
`
export default function Index(props) {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(Actions.master.setPath("/register"))    
    dispatch(Actions.popup.toggleVisible(false))
  }, [dispatch])

  return (
    <Section className={"section-form section-form-register" + (props.className ? props.className : '')}>
      <div className="section-form-register__container">
        <div className="section-heading">
          ลงทะเบียนผู้ใช้งานใหม่
        </div>
        <div className="form-register-user__container">
          <FormRegisterUser />
        </div>
      </div>
    </Section>
  )
}
